import MetaTags from 'components/meta-tags'
import React from 'react'

import { APP_URL } from '../../../app-constants/index'

type props = {
  pathname: string
  description: string
  rightHandTitle: string
}
export const GenericMetaTag: React.FC<props> = ({ pathname, description, rightHandTitle }) => {
  const qualifiedAddress = pathname ? `${APP_URL}/${pathname}` : ''
  const title = `${rightHandTitle} | Phuture`
  return <MetaTags title={title} description={description} address={qualifiedAddress} />
}

export default GenericMetaTag
